import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allEntHorDiasAction,
  setActivoEntHorDiasAction,
} from './EntHorDiasAction';
import FormEntHorDias from './components/FormEntHorDias';
import ListadoEntHorDias from './components/ListadoEntHorDias';

const EntHorDiasView = () => {
  const dispatch = Redux.useDispatch();

  const entHorDiasStore = Redux.useSelector((state) => state.entHorDias);

  const [isDelete, setIsDelete] = React.useState(false);

  return (
    <Grid container spacing={2}>
      <Grid item md={4}>
        <FormEntHorDias isDelete={isDelete} />
      </Grid>
      <Grid item md={8}>
        <BotonComponent
          click={async () => {
            await setActivoEntHorDiasAction(dispatch, null);
            await allEntHorDiasAction(dispatch, entHorDiasStore.params);
          }}
          disabled={
            entHorDiasStore.all.length === 0 && entHorDiasStore.loadingAll
          }
          white
          refreshIcon
          text={entHorDiasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
        <ListadoEntHorDias
          isDelete={isDelete}
          setIsDelete={(v) => setIsDelete(v)}
        />
      </Grid>
    </Grid>
  );
};

export default EntHorDiasView;
